import { Container, CssBaseline, Grid, ThemeProvider, Typography, createTheme, styled } from '@mui/material';
import './PublicAuth.css'
import { SignUpForm } from 'src/sections/auth/login2';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { Helmet } from 'react-helmet-async';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';


const theme = createTheme({
    palette: {
        mode: 'dark',
        background: {
            default: '#264162'
        },
        primary: {
            main: '#98C03C',
        },
        secondary: {
            main: '#1162ae',
        },
        neutral: {
            main: '#404040',
            contrastText: '#fff',
        },
    }
})

const BackgroundGrid = styled(Grid)({
});

const Logo = styled('img')({
    width: '100%',
    height: 'auto'
});



export default function SignUp() {
    const [queryParams, setQueryParams] = useSearchParams();
    const [discordUsername, setDiscordUsername] = useState();
    const [discordId, setDiscordId] = useState();
    const [discordFullDetails, setDiscordFullDetails] = useState();
    const [discordRedirect, setDiscordRedirect] = useState(false);
    const [status, setStatus] = useState("none");

    useEffect(() => {
        const fragment = new URLSearchParams(window.location.hash.slice(1));
        const [accessToken, tokenType] = [fragment.get('access_token'), fragment.get('token_type')];

        if (accessToken) {
            setDiscordRedirect(true);
            fetch('https://discord.com/api/users/@me', {
                headers: {
                    authorization: `${tokenType} ${accessToken}`,
                },
            })
                .then(result => result.json())
                .then(response => {
                    console.log(response);
                    setDiscordFullDetails(JSON.stringify(response))
                    const { username, discriminator, id } = response;
                    //set username string
                    setDiscordUsername(`${username}#${discriminator}`)
                    setDiscordId(id);
                })
                .catch(console.error);
        }
        
    }, [])

    useEffect(() => {
        if (queryParams.has('data') && queryParams.has('code') && !discordRedirect) {
            setStatus('loginToVerify');
        } else {
        if (discordRedirect) {
            setStatus('profileInfo');
        }
        if (queryParams.has('page')) {
            setStatus(queryParams.get('page'));
        }
    }
    }, [discordRedirect])

    useEffect(() => {
        const documentBody = document.body;
        documentBody.classList.add('auth-bg');
    
        return function removeBackground() {
          const documentBody = document.body;
          documentBody.classList.remove('auth-bg');
        }
      }, []);

    return (
        <>
            <Helmet>
                <title>Sign-Up | Fiber Gaming Network</title>
                {/* <script async
                    src="https://maps.googleapis.com/maps/api/js?key=AIzaSyD_TuBpk6uazmaIhUceAucMSbT-0rPY2JU&libraries=places&callback=initMap">
                </script> */}
            </Helmet>

                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <BackgroundGrid container justifyContent='center' paddingBottom={6} sx={{pt: {xs: 2, md: 5}}} minHeight='100vh'>
                        <Container maxWidth='sm'>
                            <Grid container justifyContent='center' alignContent='center'>
                                <Grid item xs={12}>
                                    {status && (status !== 'none') &&
                                    <>
                                        {console.log(status)}
                                        <SignUpForm verified={status} profileData={(status === 'loginToVerify') ? atob(queryParams.get('data')) : null} code={(status === 'loginToVerify') ? queryParams.get('code') : null} discordUsername={discordUsername ? discordUsername: null} discordId={discordId ? discordId: null} discordFullDetails={discordFullDetails ? discordFullDetails: null} signupOnly />
                                    </>
                                    }
                                    {status && (status === 'none') &&
                                    <>
                                        {console.log(status)}
                                        <SignUpForm verified={'none'} inviteCode={queryParams.has('event') ? queryParams.get('event') : ''} profileData={(status === 'loginToVerify') ? atob(queryParams.get('data')) : null} code={(status === 'loginToVerify') ? queryParams.get('code') : null} discordUsername={discordUsername ? discordUsername: null} discordId={discordId ? discordId: null} discordFullDetails={discordFullDetails ? discordFullDetails: null} signupOnly />
                                    </>
                                    }
                                        
                                </Grid>
                            </Grid>
                        </Container>
                    </BackgroundGrid>

                </ThemeProvider>
        </>
    )
}